import moment from "moment";
import { FormattedMessage } from "react-intl";  

const clientStatuses = [
  {
    name: "Enabled",
    value: <FormattedMessage id="CLIENT.ENABLED.STATUS.MESSAGE" />,
  },
  {
    name: "Disabled",
    value: <FormattedMessage id="CLIENT.DISABLED.STATUS.MESSAGE" />,
  },
];

const userStatuses = [
  {
    name: "Active",
    value: <FormattedMessage id="TEAMS.STATUS.ENABLED.CONDITIONS" />,
  },
  {
    name: "Pending",
    value: <FormattedMessage id="TEAMS.STATUS.PENDING.CONDITIONS" />,
  },
  {
    name: "Inactive / Disabled User",
    value: <FormattedMessage id="TEAMS.STATUS.DISABLED.CONDITIONS" />,
  },
  {
    name: "Link Expired",
    value: <FormattedMessage id="TEAMS.STATUS.EXPIRED.CONDITIONS" />,
  },
];

const activityStatuses = [
  {
    name: "Success",
    value: <FormattedMessage id="ACTIVITY.STATUS.SUCCESS.CONDITIONS" />,
  },
  {
    name: "Failed",
    value: <FormattedMessage id="ACTIVITY.STATUS.FAILED.CONDITIONS" />,
  },
];

const Atag = ({ href, value }) => (
  <>
    <a target="_blank" className="underline" href={href} rel={"noreferrer"}>
      {value}
    </a>
  </>
);

// intro steps
const introSteps = [
  {
    step: (
      <p>
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP1.START" />
        <Atag
          href={
            "https://play.google.com/store/apps/details?id=com.azure.authenticator&pcampaignid=web_share"
          }
          value={"Play Store"}
        />
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP1.MID" />
        <Atag
          href={
            "https://apps.apple.com/in/app/microsoft-authenticator/id983156458"
          }
          value={"App Store"}
        />
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP1.END" />
      </p>
    ),
  },
  {
    step: (
      <p>
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP2" />
      </p>
    ),
  },
  {
    step: (
      <p>
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP3" />{" "}
      </p>
    ),
  },
  {
    step: (
      <p>
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP4" />{" "}
      </p>
    ),
  },
  {
    step: (
      <p>
        <FormattedMessage id="VERIFY.OTP.TOUR.STEP5" />{" "}
      </p>
    ),
  },
];

const downloadLink =
  "https://support.microsoft.com/en-us/account-billing/download-and-install-the-microsoft-authenticator-app-351498fc-850a-45da-b7b6-27e523b8702a";

const screenHeight = Number?.isNaN(window.innerHeight)
  ? window.clientHeight
  : window.innerHeight;

const screenWidth = Number?.isNaN(window.innerWidth)
  ? window.innerWidth
  : window.innerWidth;

const maximumMBSize = (MB) => MB * 1024 * 1024; // In MegaBytes

const frequencyOptions = [
  { id: 1, title: "Monthly", value: "monthly" },
  // { id: 2, title: "Weekly", value: "weekly" },
  // { id: 3, title: "BiWeekly", value: "biweekly" },
];

 

const hexToRgba = (hex, alpha = 1) => {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    const c = hex.substring(1).split("");
    if (c.length === 3) {
      c.push(c[0], c[1], c[2]);
    }
    const color = parseInt("0x" + c.join(""));
    const r = (color >> 16) & 255;
    const g = (color >> 8) & 255;
    const b = color & 255;
    return `rgba(${r},${g},${b},${alpha})`;
  }
};

const trimColor = (color) =>
  color?.startsWith("bg-[") || color?.startsWith("border-[")
    ? "#" + color?.match(/#([A-Fa-f0-9]{6})/)?.[1]
    : "";

const getPreviousBusinessDay = (holidays, day) => {
  let today = moment(day);
  let i = 0;
  if (holidays?.includes(today.format("ddd").toLowerCase())) {
    do {
      i++;
      today.subtract(1, "days"); // Move to previous day
    } while (holidays.includes(today.format("ddd").toLowerCase()));
  }
  return { workingDay: today.format("MM-DD-YYYY"), noOfTimes: i };
};

const getNextBusinessDay = (holidays, day, month) => {
  let nextDay = moment(day);
  let i = 0;
  do {
    i++;
    nextDay.add(1, "days"); // Move to the next day
  } while (holidays.includes(nextDay.format("ddd").toLowerCase()));

  return {
    workingDay:nextDay.format("MM-DD-YYYY"),
    noOfTimes: i,
  };
};

const numberToWords = (num) => {
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const convertChunk = (chunk) => {
    if (chunk === 0) return '';
    if (chunk < 10) return units[chunk];
    if (chunk < 20) return teens[chunk - 10];
    const tensDigit = Math.floor(chunk / 10);
    const onesDigit = chunk % 10;
    return tens[tensDigit] + (onesDigit > 0 ? ` ${units[onesDigit]}` : '');
  };

  const convertNumberToWords = (number) => {
    if (number === 0) return 'Zero';

    const thousands = Math.floor(number / 1000);
    const hundreds = Math.floor((number % 1000) / 100);
    const remainder = number % 100;

    let result = '';
    if (thousands > 0) {
      result += `${convertChunk(thousands)} Thousand `;
    }
    if (hundreds > 0) {
      result += `${convertChunk(hundreds)} Hundred `;
    }
    if (remainder > 0) {
      result += convertChunk(remainder);
    }

    return result.trim();
  };

  const words = convertNumberToWords(num);
  return `${words} rupees only`;
};

export {
  numberToWords,
  getNextBusinessDay,
  getPreviousBusinessDay,
  trimColor,
  hexToRgba, 
  frequencyOptions,
  clientStatuses,
  userStatuses,
  activityStatuses,
  introSteps,
  downloadLink,
  screenHeight, 
  maximumMBSize,
  screenWidth,
};
